module.exports = __webpack_public_path__ + "static/media/berth.c4de3a3e.jpg";